export default [{
  "access_denied_title": "Access not available",
  "access_denied_label": "You're not enabled to access the platform with these credentials.",
  "access_denied_contact_administrators": "Contact your system administrator for more info.",
}]